/* eslint-disable no-prototype-builtins */
import { toastError, toastInfo, toastWarning } from './toastMessage';

function createErrorByType(errorType = 'error', errorMess) {
  switch (errorType) {
    case 'info': {
      toastInfo(errorMess);
      break;
    }
    case 'error': {
      toastError(errorMess);
      break;
    }
    case 'warning': {
      toastWarning(errorMess);
      break;
    }
    default: {
      toastError(errorMess);
    }
  }
}

export default function errorHandler(errorStatus = 500, errorConfig) {
  switch (errorStatus) {
    case 404: {
      if (errorConfig && errorConfig.hasOwnProperty(404)) {
        createErrorByType(
          errorConfig[404].type,
          errorConfig[404].message || 'Информация не найдена',
        );
        break;
      }
      toastError('Информация не найдена');
      break;
    }
    case 400: {
      if (errorConfig && errorConfig.hasOwnProperty(400)) {
        createErrorByType(
          errorConfig[400].type,
          errorConfig[400].message || 'Выполнить операцию не удалось',
        );
        break;
      }
      toastError('Выполнить операцию не удалось');
      break;
    }
    default: {
      toastError();
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/errorHandler.js